<script>
    import Layout from "../../layouts/main";
    import ConnectCard from "../../../components/connectCard";
    import YoutubeOverview from "../../../components/youtubeOverview";
    import axios from "axios";
    import {mapState} from "vuex";
    import YoutubePosts from "../../../components/youtubePosts";
    import {snakeToWords} from "@/state/helpers";

    export default {
        page: {
            title: "Youtube",
            meta: [{name: "description", content: ''}],
        },
        components: {
            YoutubePosts,
            Layout,
            ConnectCard,
            YoutubeOverview
        },
        data() {
            return {
                authResponse: {},
                pages: [],
                showError: false,
                errorMessage: 'Something went wrong.'
            };
        },
        computed: {
            ...mapState('user', {
                user: (state) => state.user
            }),
            youtube() {
                return this.user.social_network_accounts && this.user.social_network_accounts.youtube;
            },
            connected() {
                return this.youtube;
            },
            initialTab() {
                return this.$route.query.tab;
            }
        },
        created() {
            this.addYoutubeScript();
        },
        methods: {
            snakeToWords: snakeToWords,
            addYoutubeScript() {
                const youtubeScript = document.createElement('script');
                youtubeScript.setAttribute('src', 'https://apis.google.com/js/api.js');
                youtubeScript.setAttribute('async', '');
                youtubeScript.setAttribute('defer', '');
                document.body.appendChild(youtubeScript);
            },

            async youtubeAuth2callback(googleResponse) {
                if (googleResponse.hasOwnProperty('error')) { //User didn't approve permission
                    this.errorMessage = snakeToWords(googleResponse.error)
                    this.showError = true;
                    // eslint-disable-next-line no-console
                    console.error(googleResponse.error);
                    return;
                }
                try {
                  const { data } = await axios.post("profile/youtube/connect", {'code': googleResponse.code, redirect_url: window.location.origin });
                  if (Array.isArray(data.profile) && data.profile.length === 0) {
                      this.errorMessage = 'There is no Youtube Channel for this account.';
                        this.showError = true;
                  } else {
                      this.$store.commit('user/SET_USER', data.profile);
                      // force refresh
                      window.location = '/youtube';
                  }
                } catch (err) {
                  if (err.response && err.response.data && err.response.data.message) {
                      this.errorMessage = err.response.data.message;
                  }
                  this.showError = true;
                  // eslint-disable-next-line no-console
                  console.error(err);
                }
            },
            async authorizeYoutube() {
                // this.$store.commit('loader/START_LOADING');
                //TODO use ajax to /auth2/configuration
                const { data } = await axios.get('/youtube/auth2/configuration');
                delete data.cookie_policy;
                gapi.auth2.authorize(data, this.youtubeAuth2callback);
            },
            loadYoutubeAuth2Module() {
                gapi.load('auth2', this.authorizeYoutube);
            }
        }
    }
    ;
</script>

<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <b-alert
                        v-model="showError"
                        class="mt-3"
                        variant="danger"
                        dismissible
                >{{ errorMessage }}</b-alert>
            </div>
        </div>
        <div v-if="connected" class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <b-tabs nav-class="nav-tabs-custom" content-class="text-muted">
                            <b-tab :active="!initialTab">
                                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-chart-bar"></i>
                  </span>
                                    <span class="d-none d-sm-inline-block">Overview</span>
                                </template>

                                <YoutubeOverview />

                            </b-tab>
                            <b-tab :active="initialTab === 'posts'">
                                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-video"></i>
                  </span>
                                    <span class="d-none d-sm-inline-block">Videos</span>
                                </template>

                                <YoutubePosts/>

                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row">
            <div class="col">
                <ConnectCard social-network="Youtube" @connect="loadYoutubeAuth2Module"/>
            </div>

<!--            <b-modal v-model="showModal" :title="`Choose your account`" size="lg" hide-footer centered>-->
<!--                <div class="row my-5 justify-content-center">-->
<!--                    <div class="col-8">-->
<!--                        <button v-for="page in pages" :key="page.name" @click="choosePage(page.id)"-->
<!--                                class="btn btn-block btn-primary my-3 btn-facebook">-->
<!--                            <img-->
<!--                                    class="rounded-circle header-profile-user mr-3"-->
<!--                                    :src="page.picture.data.url"-->
<!--                                    alt="Header Avatar"-->
<!--                            />-->
<!--                            {{ page.name }}-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </b-modal>-->
        </div>

    </Layout>
</template>
